import { apiClient } from '@/api/client';
import type {
  ActivePoliciesResponseWire,
  UnacceptedPoliciesResponseWire,
  PolicyVersionWire,
  PolicyContentWire,
  UserPolicyAcceptanceWire,
  AcceptanceMethod,
} from '../schemas/policy';

export async function getActivePolicies(): Promise<ActivePoliciesResponseWire> {
  return apiClient.get<ActivePoliciesResponseWire>('/api/v1/policies/active');
}

export async function getUnacceptedPolicies(): Promise<UnacceptedPoliciesResponseWire> {
  return apiClient.get<UnacceptedPoliciesResponseWire>('/api/v1/policies/unaccepted');
}

export async function getPolicyVersion(
  policyId: string,
  versionId: string
): Promise<PolicyVersionWire> {
  return apiClient.get<PolicyVersionWire>(
    `/api/v1/policies/${policyId}/versions/${versionId}`
  );
}

export async function getPolicyContent(
  policyId: string,
  versionId: string
): Promise<PolicyContentWire> {
  return apiClient.get<PolicyContentWire>(
    `/api/v1/policies/${policyId}/versions/${versionId}/content`
  );
}

export async function acceptPolicy(
  policyId: string,
  versionId: string,
  acceptanceMethod: AcceptanceMethod
): Promise<UserPolicyAcceptanceWire> {
  return apiClient.post<UserPolicyAcceptanceWire>(
    `/api/v1/policies/${policyId}/versions/${versionId}/accept`,
    { acceptance_method: acceptanceMethod }
  );
}

export async function getUserPolicyAcceptances(): Promise<UserPolicyAcceptanceWire[]> {
  return apiClient.get<UserPolicyAcceptanceWire[]>('/api/v1/users/me/policy-acceptances');
}
